var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VAlert',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],style:(_vm.style),attrs:{"type":_vm.type,"transition":"fade-transition","dismissible":""},on:{"close":_vm.close}},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }